import { EventEmitter } from "events";
export const DrawEvent = new EventEmitter();
